var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.sections),function(section,index){return _c('section',{key:index,staticClass:"first-access-section",class:{
      'first-access-section__content': true,
      'first-access-section__content--last': index === _vm.sections.length - 1
    }},[_c('StatusMessage',{staticClass:"first-access-section__content--text",attrs:{"title":section.title,"type":"info","icon":section.icon}},[_vm._v(" "+_vm._s(section.text)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }